import React from 'react';
import { formatInboxTime, truncateMessagePreview } from '../../utils/inboxHelpers';

const ConversationItem = ({ conversation, isActive, onClick }) => {
    // Format the display time from lastUpdated or lastMessageAt
    const displayTime = formatInboxTime(conversation.lastUpdated || conversation.lastMessageAt || conversation.time);

    // Get truncated message preview
    const messagePreview = truncateMessagePreview(
        conversation.lastMessage || conversation.preview || '',
        40,
        {
            hasAttachment: conversation.hasAttachment,
            attachmentType: conversation.attachmentType,
            isSystem: conversation.isSystemMessage,
        }
    );

    // Check for unread: support both unreadCount (new) and boolean unread (legacy)
    const hasUnread = (conversation.unreadCount > 0) || (conversation.unread === true);

    return (
        <div
            onClick={onClick}
            className={`p-4 border-b border-notion-border hover:bg-notion-sidebar cursor-pointer transition-colors group ${isActive ? 'bg-notion-sidebar' : ''
                }`}
        >
            <div className="flex justify-between items-baseline mb-1">
                <h3 className={`text-sm text-notion-text ${hasUnread ? 'font-semibold' : 'font-medium'}`}>
                    {conversation.name}
                </h3>
                <span className="text-[10px] text-notion-text-light flex-shrink-0 ml-2">{displayTime}</span>
            </div>
            <div className="flex items-center justify-between">
                <p className="text-xs text-notion-text-light truncate w-4/5 group-hover:text-stone-600 transition-colors">
                    {messagePreview}
                </p>
                {hasUnread && (
                    <div className="flex items-center gap-1 flex-shrink-0">
                        {conversation.unreadCount > 1 && (
                            <span className="text-[10px] font-medium text-stone-600">{conversation.unreadCount}</span>
                        )}
                        <div className="w-2 h-2 rounded-full bg-stone-800"></div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConversationItem;